<template>
  <div class="box safe-distance-top-header">
    <Header :pageTitle="''" :shareInfo="shareInfo" />
    <div class="detail-box">
      <div class="baseinfo-box">
        <div class="logo-box">
          <img
            class="photo"
            :src="
              userInfo.headPhoto
                ? $global.imgUrl + userInfo.headPhoto
                : require('@/assets/img/mobile-img/default-photo.png')
            "
            alt=""
          />
          <div class="name-box">
            <h2>{{ userInfo.realname }}</h2>
            <p>{{ userInfo.unit }}</p>
            <div>
              <span v-for="item in sysUserTitle" :key="item.id">
                <span class="title_span" v-if="item.levelOne !== 5">{{
                  item.levelTwo
                }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="study-box">
          <span class="study-label">研究方向：</span>
          <span>{{ userInfo.researchDirection }}</span>
        </div>
        <div class="statistics-box">
          <div class="statistics-item">
            <span class="statistics-number">{{
              userAmount.achievementCount
            }}</span>
            <span class="statistics-label">学术成果</span>
          </div>
          <div class="statistics-item">
            <span class="statistics-number">{{
              userAmount.relationAuthorCount
            }}</span>
            <span class="statistics-label">合作学者</span>
          </div>
          <div class="statistics-item">
            <span class="statistics-number">{{
              userAmount.classifyNumberCount
            }}</span>
            <span class="statistics-label">发文学科</span>
          </div>
          <div class="statistics-item">
            <span class="statistics-number">{{
              userAmount.periodicalOrigCount
            }}</span>
            <span class="statistics-label">发文期刊</span>
          </div>
        </div>
      </div>
      <div class="tabs-box">
        <van-tabs
          class="tab-box"
          :ellipsis="false"
          color="#4a79f1"
          title-active-color="#4a79f1"
          title-inactive-color="#333"
        >
          <van-tab title="基本信息">
            <div class="tabs-info">
              <div class="info-lab">学者姓名</div>
              <div class="info-content">{{ userInfo.realname }}</div>
            </div>
            <div
              class="tabs-info"
              v-if="
                sysUserTitle.length &&
                sysUserTitle.some((item) => item.levelOne !== 5)
              "
            >
              <div class="info-lab">职称</div>
              <div class="info-content">
                <div v-for="item in sysUserTitle" :key="item.id">
                  <p v-if="item.levelOne !== 5">
                    {{ `${item.levelTwo}（${item.levelOneName}）` }}
                  </p>
                </div>
              </div>
            </div>
            <div class="tabs-info" v-if="userInfo.researchDirection">
              <div class="info-lab">研究方向</div>
              <div class="info-content">{{ userInfo.researchDirection }}</div>
            </div>
            <div class="tabs-info" v-if="sysUserSubject.length">
              <div class="info-lab">学科领域</div>
              <div class="info-content">
                <p v-for="item in sysUserSubject" :key="item.id">
                  {{ item.levelOneName }} - {{ item.levelTwoName }}
                </p>
              </div>
            </div>
            <div class="tabs-info" v-if="scholarPresentUnit.length">
              <div class="info-lab">任职机构</div>
              <div class="info-content">
                <p v-for="item in scholarPresentUnit" :key="item.id">
                  <span style="color: #4a79f1" @click="toUnit(item.orgId)">{{
                    item.unitName
                  }}</span>
                  <span> - </span>
                  <span>{{ item.job }}</span>
                </p>
              </div>
            </div>
            <div class="tabs-info" v-if="userInfo.education">
              <div class="info-lab">学历/学位</div>
              <div class="info-content">
                <span>{{ userInfo.education }}</span>
                <span v-show="userInfo.inStudy == 1">（在读）</span>
              </div>
            </div>
            <div class="tabs-info" v-if="userInfo.school">
              <div class="info-lab">毕业院校</div>
              <div class="info-content">{{ userInfo.school }}</div>
            </div>
            <div class="tabs-intro" v-if="userInfo.profile">
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">个人简介</span>
              </div>
              <p class="intro-text">{{ userInfo.profile }}</p>
            </div>
            <div
              class="tabs-intro"
              v-for="item in scholarExperiences"
              :key="item.type"
            >
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">{{ item.type | filterExperiences }}</span>
              </div>
              <p class="intro-text">
                {{ item.content }}
              </p>
            </div>
            <!-- <div class="tabs-intro" v-if="scholarExperiences[0]">
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">教育背景</span>
              </div>
              <p class="intro-text">
                {{ scholarExperiences[0].content }}
              </p>
            </div>
            <div class="tabs-intro" v-if="scholarExperiences[3]">
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">工作经历</span>
              </div>
              <p class="intro-text">
                {{ scholarExperiences[3].content }}
              </p>
            </div>
            <div class="tabs-intro" v-if="scholarExperiences[1]">
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">职称经历</span>
              </div>
              <p class="intro-text">
                {{ scholarExperiences[1].content }}
              </p>
            </div>
            <div class="tabs-intro" v-if="scholarExperiences[2]">
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">社会任职</span>
              </div>
              <p class="intro-text">
                {{ scholarExperiences[2].content }}
              </p>
            </div> -->
            <div class="tabs-intro" v-if="prize && prize.content">
              <div class="intro-title">
                <span class="icon"></span>
                <span class="title">获奖情况</span>
              </div>
              <p class="intro-text">{{ prize.content }}</p>
            </div>
          </van-tab>
          <van-tab title="学术成果">
            <div class="science-btn">成果浏览</div>
            <DetailList
              listType="0"
              :argumentObj="argumentObj"
              :listRequest="getInformation"
            />
          </van-tab>
          <van-tab title="合作学者">
            <div class="table-box">
              <div class="table-tr table-th">
                <span class="table-td">序号</span>
                <span class="table-td">学者</span>
                <span class="table-td">合作成果</span>
              </div>
              <div
                class="table-tr"
                v-for="(item, index) in userList.relationAuthor"
                :key="index"
                @click="toDetail(item.authorId, 0)"
              >
                <span class="table-td">{{ index + 1 }}</span>
                <span class="table-td">{{ item.value }}</span>
                <span class="table-td">{{ item.count + "篇" }}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="发文学科">
            <div class="table-box">
              <div class="table-tr table-th">
                <span class="table-td">序号</span>
                <span class="table-td">学科</span>
                <span class="table-td">合作成果</span>
              </div>
              <div
                class="table-tr"
                v-for="(item, index) in userList.classifyNumber"
                :key="index"
              >
                <span class="table-td">{{ index + 1 }}</span>
                <span class="table-td">{{ item.classifyName }}</span>
                <span class="table-td">{{ item.count + "篇" }}</span>
              </div>
            </div></van-tab
          >
          <van-tab title="发文期刊">
            <div class="table-box">
              <div class="table-tr table-th">
                <span class="table-td">序号</span>
                <span class="table-td">期刊</span>
                <span class="table-td">合作成果</span>
              </div>
              <div
                class="table-tr"
                v-for="(item, index) in userList.periodicalOrig"
                :key="index"
                @click="toDetail(item.periodical_id, 1)"
              >
                <span class="table-td">{{ index + 1 }}</span>
                <span class="table-td">{{ item.value }}</span>
                <span class="table-td">{{ item.count + "篇" }}</span>
              </div>
            </div></van-tab
          >
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/detailHeader.vue";
import DetailList from "./components/detailList.vue";
export default {
  components: {
    Header,
    DetailList,
  },
  data() {
    return {
      userInfo: {}, //学者基本信息
      userAmount: {
        // 学术成果  合作学者 发文学科 发文期刊
        achievementCount: 0,
        relationAuthorCount: 0,
        classifyNumberCount: 0,
        periodicalOrigCount: 0,
      },
      userList: {
        // 合作学者 发布学科 发布期刊列表
        relationAuthor: [],
        classifyNumber: [],
        periodicalOrig: [],
      },
      sysUserSubject: [], //学者学科领域
      sysUserTitle: [], //学者职称
      scholarExperiences: [], // 学者个人履历
      scholarPresentUnit: [], // 任职机构
      prize: {}, // 获奖情况
      shareInfo: {},
      argumentObj: {
        userId: this.$route.query.id,
      },
    };
  },
  created() {
    this.getDetailInfo();
    this.getArticleList();
  },
  filters: {
    filterExperiences(value) {
      switch (value) {
        case 6:
          return "教育背景";
        case 7:
          return "职称经历";
        case 8:
          return "社会任职";
        case 9:
          return "工作经历";
      }
    },
  },
  methods: {
    toDetail(id, type) {
      let out = this.$route.query.out;
      switch (type) {
        case 0:
          this.$router.push({
            path: "/appusesbaijia",
            query: {
              item: 0,
              id,
              out,
            },
          });
          break;
        case 1:
          this.$router.push({
            path: "/appusesbaike",
            query: {
              item: 1,
              id,
              out,
            },
          });
          break;
      }
    },
    toUnit(orgId) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesinstitutions",
        query: {
          type: 2,
          orgId,
          out,
        },
      });
    },
    // 获取合作学者,发文等列表和数量
    async getArticleList() {
      const { content } = await this.$apis.hundredServe.getBjArticleList({
        userId: this.$route.query.id,
      });
      console.log(content);
      for (const key in this.userAmount) {
        this.userAmount[key] = content[key];
      }
      for (const key in this.userList) {
        this.userList[key] = content[key];
      }
    },
    // 获取用户信息
    async getDetailInfo() {
      const res = await this.$apis.hundredServe.bjDetailList({
        userId: this.$route.query.id,
      });
      if (res.resultCode === "200") {
        this.userInfo = res.content.detail.userInfo;
        this.sysUserSubject = res.content.detail.sysUserSubject
          ? res.content.detail.sysUserSubject
          : [];
        this.scholarPresentUnit = res.content.detail.scholarPresentUnit
          ? res.content.detail.scholarPresentUnit
          : [];
        this.sysUserTitle = res.content.detail.sysUserTitle
          ? res.content.detail.sysUserTitle
          : [];
        this.scholarExperiences = res.content.detail.scholarExperiences
          ? res.content.detail.scholarExperiences
          : [];
        this.getPrizeInfo();
        this.shareInfo = {
          title: this.userInfo.realname,
          artSummary: this.userInfo.profile,
          cover: this.userInfo.headPhoto,
          unit: this.userInfo.unit,
          articleId: this.$route.query.id,
          userType: this.$route.query.item,
        };
        this.$global.toShare(
          this.userInfo.nickname,
          this.userInfo.profile,
          this.userInfo.cover
        );
      } else {
        console.log(res);
      }
    },
    // 获取获奖情况
    async getPrizeInfo() {
      let res = await this.$apis.userServe.spaceScholarPrize({
        userId: this.$route.query.id,
      });
      this.prize = res.data;
    },
    // 获取学术成果列表
    async getInformation(params) {
      let res = await this.$apis.hundredServe.getBjArticleList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.content.achievement.list,
          total: res.content.achievement.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding-top: 56px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  .detail-box {
    padding: 0 12px;
    .baseinfo-box {
      margin-bottom: 12px;
      padding: 16px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      .logo-box {
        display: flex;
        .photo {
          margin-right: 15px;
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .name-box {
          flex: 1;
          h2 {
            font-size: 16px;
            color: #333333;
            line-height: 24px;
          }
          p {
            margin: 10px 0 12px;
            font-size: 14px;
            color: #999999;
            line-height: 24px;
          }
          div {
            .title_span {
              display: inline-block;
              margin-right: 10px;
              margin-bottom: 5px;
              padding: 6px 7px;
              font-size: 13px;
              color: #4979f1;
              background-color: #edf3fd;
              border-radius: 4px;
            }
          }
        }
        // justify-content: center;
      }
      .study-box {
        margin-top: 19px;
        font-size: 14px;
        color: #333333;
        line-height: 21px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        .study-label {
          font-weight: 700;
        }
      }
      .statistics-box {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        padding-top: 18px;
        border-top: 1px solid #f0f0f0;
        .statistics-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .statistics-number {
            font-size: 17px;
            font-weight: 700;
            color: #333333;
            line-height: 21px;
            max-width: 60px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .statistics-label {
            font-size: 12px;
            color: #999999;
            line-height: 21px;
          }
        }
      }
    }
    .tabs-box {
      margin-bottom: 12px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .tab-box {
        &::v-deep .van-tabs__wrap {
          .van-tabs__nav {
            padding-left: 0;
            padding-right: 0;
            .van-tab__text {
              font-size: 15px;
            }
            .van-tab--active {
              .van-tab__text {
                font-weight: 700;
              }
            }
          }
        }
        &::v-deep .van-tabs__content {
          padding: 16px;
        }
        .tabs-info {
          display: flex;
          margin-bottom: 15px;
          font-size: 14px;
          color: #333333;
          line-height: 24px;
          .info-lab {
            margin-right: 25px;
            width: 80px;
          }
          .info-content {
            flex: 1;
          }
        }
        .tabs-intro {
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 1px solid #ededed;
          &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
          }
          .intro-title {
            margin-bottom: 20px;
            .icon {
              display: inline-block;
              margin-right: 9px;
              width: 4px;
              height: 13px;
              background-color: #4979f1;
            }
            .title {
              font-size: 16px;
              font-weight: 700;
              color: #333333;
              line-height: 24px;
            }
          }
          .intro-text {
            font-size: 14px;
            color: #333333;
            line-height: 23px;
          }
        }
        .science-btn {
          width: 75px;
          height: 29px;
          text-align: center;
          background-color: #4979f1;
          border-radius: 15px;
          font-size: 13px;
          color: #ffffff;
          line-height: 29px;
        }
        .table-box {
          .table-tr {
            border-bottom: 1px solid #ededed;
            &:last-child {
              border-bottom: none;
            }
            .table-td {
              display: inline-block;
              font-size: 14px;
              color: #494949;
              line-height: 54px;
              height: 54px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &:first-child {
                margin-right: 10%;
                width: 10%;
                text-align: center;
              }
              &:nth-child(2n) {
                width: 60%;
              }
              &:last-child {
                width: 20%;
                text-align: center;
              }
            }
          }
          .table-th {
            border-bottom: none;
            .table-td {
              font-size: 15px;
              font-weight: 700;
              color: #494949;
              line-height: 23px;
              height: 23px;
              &:first-child {
                text-align: left;
              }
              &:nth-child(2n) {
              }
              &:last-child {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}
</style>
